/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

const customerDeclaration = async ({ leadId, name, place, insurerType }: any) => {
  try {
    const reqBody = {
      leadId,
      customerDeclarationMode: "By OTP",
      policyHolderName: name,
      policyHolderPlace: place,
      insurerType: insurerType.insurerType
      // mefSubmittedDate: new Date()
    };
    const response: any = await axiosInstance.put(API_URLS.customerDeclaration, reqBody, {
      headers: {
        token: StorageService.getFromLocalStorage("verificationToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export default customerDeclaration;
